import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'

import './product_search_form.scss'

export const ProductSearchForm = ({ setQuery }) => {
  const { register, watch } = useForm()

  useEffect(() => {
    const subscription = watch((value) => {
      setQuery(value.search)
    })
    return () => subscription.unsubscribe()
  }, [watch])

  return (
    <>
      <form id="product-search-form" className="product-search-form">
        <div className="form-item search-input-item">
          <FontAwesomeIcon icon={faMagnifyingGlass} />
          <input 
            placeholder="Search for products" 
            autoComplete="off" 
            className="search-input" 
            type="text" 
            {...register('search')} />
        </div>
      </form>
    </>
  )
}
